import { AgentDatasetSchema } from "@redotech/redo-model/agents/agent-dataset";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAgentDatasets = {
  name: "getAgentDatasets" as const,
  input: z.object({
    agentName: z.string(),
    team: zExt.objectId().optional(),
    limit: z.number().optional().default(20),
    cursor: z.string().optional(), // cursor for infinite scroll (ISO date string)
  }),
  output: z.object({
    data: z.array(AgentDatasetSchema),
    hasMore: z.boolean(),
    nextCursor: z.string().optional(),
  }),
};
